export default __webpack_public_path__ + "static/media/Rectangle3.b29de909.png";